import { reset, SubmissionError } from 'redux-form';
import http from '../../../shared/http';
import endpoints from '../../../../config/endpoints';
import { actions as parentActions } from '../../profile';

import _path from 'lodash/fp/path';
import _forEach from 'lodash/fp/forEach';

const defaultInitialState = {
	fields: {
		sourceAffiliateId: null,
		targetAffiliateId: null,
		comment: null
	},
	isShow: false
};

const prepareFormErrors = errors => {
	const validationsErrors = {};
	_forEach(value => {
		const key = value.dataPath.slice(1);
		validationsErrors[key] = value.message;
	}, errors);
	return validationsErrors;
};

const errorReducerFn = (state, action) => {
	if (action.payload.response.status !== 400) {
		return { ...state, error: true, showProgressBar: false };
	}
	return state;
};

const createForm = ({ namespace, stateNodeName, formName }) => {
	const FORM_SUBMIT_SUCCESS = `${namespace}/${stateNodeName}-submit-transfer-balance-form-success`;
	const FORM_SUBMIT_ERROR = `${namespace}/${stateNodeName}-submit-transfer-balance-form-error`;
	const TOGGLE_FORM = `${namespace}/${stateNodeName}-toggle-transfer-balance-form`;

	const initialState = { ...defaultInitialState };

	const actions = {
		submitForm: formData => (dispatch, getState) => {
			const getAffiliateId = _path([0, 'value']);

			const sourceAffiliateId = getAffiliateId(formData.sourceAffiliateId);
			const targetAffiliateId = getAffiliateId(formData.targetAffiliateId);

			const request = http({
				url: endpoints.AFFILIATES.TRANSFER_BALANCE_AND_ACCUMULATED_POINTS,
				method: 'post',
				actions: [FORM_SUBMIT_SUCCESS, FORM_SUBMIT_ERROR],
				data: {
					sourceAffiliateId,
					targetAffiliateId,
					comment: formData.comment
				}
			});

			return dispatch(request)
				.then(action => {
					if (action.type === FORM_SUBMIT_SUCCESS) {
						dispatch(parentActions.fetchData({ params: { id: sourceAffiliateId }}));
						dispatch(actions.toggleForm());
					}
					if (action.type === FORM_SUBMIT_ERROR && action.payload.response.status === 400) {
						const responseErrors = action.payload.response.data;
						throw new SubmissionError(prepareFormErrors(responseErrors));
					}
				});
		},
		toggleForm: () => dispatch => {
			dispatch(reset(formName));
			dispatch({ type: TOGGLE_FORM });
		}
	};

	const reducers = {
		[TOGGLE_FORM]: (state, action) => ({
			...state,
			[stateNodeName]: {
				isShow: !state[stateNodeName].isShow
			}
		}),
		[FORM_SUBMIT_ERROR]: errorReducerFn
	};

	const selectors = {
		getFormData: state => ({
			initialValues: state[namespace][stateNodeName].fields
		}),
		getShouldShowStatus: state => state[namespace][stateNodeName].isShow
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createForm;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/create-transfer-balance-and-accumulated-points-form/index.js